import { Injectable } from '@angular/core';
import { AppComponentEventsService } from '../events/app-component-events.service';
import { Observable, tap } from 'rxjs';
import { LoginRequest } from '../models/requests/login-request';
import { environment } from '../environments/environments';
import { HttpClient } from '@angular/common/http';
import { localStoragevarNames } from '../utilities/local-storage-utils';
import { Router } from '@angular/router';
import { pathNames } from '../utilities/routing-path-utils';
import { UserResponse } from '../models/responses/user-response';
import { getConnectedUserFromLocalStorage } from '../utilities/user-utils';
import { UserRole } from '../models/enums/user-role';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  constructor(private appComponentEventService: AppComponentEventsService, private http: HttpClient, private router: Router) { }

  login(loginRequest: LoginRequest): Observable<UserResponse> {
    return this.http.post<UserResponse>(`${environment.authUrl}/login`, loginRequest);
  }

  isAuthenticated(): boolean {
    return localStorage.getItem(localStoragevarNames. user) != undefined;
  }

  isAdmin(): boolean {
    const connectedUser = getConnectedUserFromLocalStorage();

    if (connectedUser) {
      return connectedUser.userRole == UserRole.ADMIN;
    }else return false;
  }

  logout() {
    this.http.get(`${environment.authUrl}/logout`).subscribe(
      () => {
        localStorage.clear();
        this.appComponentEventService.onUserLogOutEvent.emit();
        this.router.navigate(['/' + pathNames.loginPath]);
      });
  }
}
